import { formatPrice } from "@mobility-item-page/utilities";
import { Card, Clickable } from "@warp-ds/react";
import { useAppConfig } from "src/context/AppConfigProviderContext.tsx";
import Favorite from "../Favorite.tsx";
import { Image } from "./Image.tsx";

// TODO: MIT-1237 - The props will change when we know how the data will be structured
type Props = {
  title?: string;
  subTitle?: string;
  image?: string;
  url: string;
  price?: number;
  ariaDescription?: string;
  adId: number;
  onClick?: () => void;
};

const ItemCard = ({ title, subTitle, image, url, ariaDescription, price, adId, onClick }: Props) => {
  const { locale, brand } = useAppConfig();
  const formattedPrice = price ? formatPrice(price, locale, brand) : "";

  const gradient =
    "linear-gradient(0deg, rgba(0, 0, 0, 0.95) 0%, rgba(0, 0, 0, 0.77) 15.625%, rgba(95, 95, 95, 0.49) 34.895%, rgba(196, 196, 196, 0.00) 50%, rgba(196, 196, 196, 0.00) 100%)";

  // The width calculation ensures that 3 cards fit within the container with 16px gaps and 16px padding on each side
  return (
    <article className="w-[304px] md:min-w-[calc((100%_-_3.2rem)/3)] card-container">
      <Card className="w-[304px] md:w-unset md:min-w-[calc((100%_-_3.2rem)/3)] shadow-[unset] aspect-19/14">
        <div className="flex items-end p-16">
          <div className="z-10">
            <Clickable
              href={url}
              rel="noopener noreferrer"
              aria-description={ariaDescription}
              className="s-text-inverted font-bold"
              onClick={onClick}
            >
              <span>{formattedPrice}</span>
            </Clickable>
            <Favorite adId={adId} />
          </div>
        </div>
        <div className="absolute inset-0" style={{ background: gradient, zIndex: 1 }} />
        <Image image={image} altText={title} />
      </Card>
      <div className="flex flex-col gap-4">
        <h3 className="card-title">{title}</h3>
        <span className="text-caption s-text-subtle">{subTitle}</span>
      </div>
    </article>
  );
};

export default ItemCard;
